import {
  AddFileToFolderDto,
  FileDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { filesApi } from "@api/services";
import { ACTION_GET_FOLDER, DOMAIN_FILES, DOMAIN_FOLDERS, roleGuard } from "@api";

// TODO move to files

export const ACTION_ADD_FILE_TO_FOLDER = "ADD_FILE_TO_FOLDER";

const allowedRoles = [UserRole.Owner];

const addFileToFolder = async (params: AddFileToFolderDto): Promise<FileDto> => {
  const response = await filesApi.filesControllerAddFileToFolder(
    params as AddFileToFolderDto,
  );

  return response.data;
};

export const useAddFileToFolder = (
  user: UserProfileDto | null,
): {
  addFileToFolderAsync: (params: AddFileToFolderDto) => Promise<FileDto>;
  addFileToFolderEnabled: boolean;
  isSuccessAddFileToFolder: boolean;
  isPendingAddFileToFolder: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutateAsync, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_FILES, ACTION_ADD_FILE_TO_FOLDER],
    mutationFn: enabled ? addFileToFolder : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_FOLDERS, ACTION_GET_FOLDER],
      });
    },
  });

  return {
    addFileToFolderAsync: mutateAsync,
    addFileToFolderEnabled: enabled,
    isSuccessAddFileToFolder: isSuccess,
    isPendingAddFileToFolder: isPending,
  };
};
